import { useEffect, useState } from "react";
import { ShieldCheck, Award, BadgeCheck, Wrench } from "lucide-react";
import { api } from "../lib/api";
import { Reveal } from "./Reveal";

const CERTS = [
  { icon: ShieldCheck, label: "Serrures certifiées A2P" },
  { icon: Award, label: "Agréé compagnies d'assurance" },
  { icon: BadgeCheck, label: "Pièces garanties" },
  { icon: Wrench, label: "Techniciens qualifiés" },
];

export default function BrandsSection({ city }) {
  const [brands, setBrands] = useState([]);
  useEffect(() => { api.get("/brands").then((r) => setBrands(r.data)).catch(() => {}); }, []);

  return (
    <section className="relative z-10 py-24 sm:py-32 bg-zinc-50 border-t border-zinc-200" data-testid="brands-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <p className="overline mb-4">Marques & certifications</p>
          <h2 className="text-4xl sm:text-5xl font-display font-semibold tracking-tighter max-w-3xl leading-[1.02] text-zinc-900">
            Les marques de serrures que nous installons{city ? ` à ${city}` : ""}
          </h2>
          <p className="text-zinc-500 mt-6 max-w-2xl leading-relaxed">
            Nous travaillons exclusivement avec des fabricants reconnus et certifiés pour garantir votre sécurité. Nos serruriers vous conseillent la marque la plus adaptée à votre porte et à votre budget.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {brands.map((b, i) => (
            <Reveal key={b.name} delay={(i % 4) * 0.05} className="card-soft rounded-2xl border border-zinc-200 bg-white p-6 shadow-sm">
              <div className="font-display text-2xl font-semibold text-zinc-900 tracking-tight">{b.name}</div>
              <p className="text-sm text-zinc-500 mt-2 leading-relaxed">{b.desc}</p>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap gap-3">
          {CERTS.map((c, i) => (
            <Reveal key={i} delay={i * 0.05} className="flex items-center gap-2.5 rounded-full border border-zinc-200 bg-white px-5 py-2.5 shadow-sm">
              <c.icon className="h-4 w-4 text-primary" />
              <span className="text-sm text-zinc-700 font-medium">{c.label}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
